/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import SERVICE_GROUPS, { serviceGroupsUrl } from 'SharedDir/backend/endpoints/service-groups';
import {
  ServiceGroupFullBrief,
  ServiceGroupUpdate,
  ServiceGroupFull,
} from 'SharedDir/declarations/service-groups';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

export default class ServiceGroupsApiClass extends SimpleApi<
  ServiceGroupFull,
  ServiceGroupUpdate,
  ServiceGroupUpdate,
  ServiceGroupFullBrief
> {
  constructor() {
    super(serviceGroupsUrl);
  }

  async getPublicList<Extra extends object>(params: PaginationParams<Extra>) {
    const { data } = (await http({
      ...SERVICE_GROUPS.PUBLIC_SERVICE_GROUPS.LIST,
      params,
    })) as AxiosResponse<Paginated<ServiceGroupFullBrief, Extra>>;
    return data;
  }

  public async getAllPublicList<Extra extends object>(
    params: Omit<PaginationParams<object>, 'rowsPerPage' | 'page'> & Extra
  ) {
    const { data } = await this.getPublicList({ ...params, rowsPerPage: null, page: 1 });
    return data;
  }
}
